module.exports = __webpack_public_path__ + "static/media/logo-footer.7b529fae.png";